import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { useNavigate } from "react-router-dom";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { tasksId } from "../../../types/activityTasks";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstructionTeam2 } from "../../../assets/imgIntruction/tema2";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	viewActivity: 100,
	dialogTwo: 2,
	dialogThree: 3,
	dialogFour: 4,
	dialogFive: 5,
	dialogSix: 6,
	dialogSeven: 7,
	dialogEight: 8,
	dialogNine: 9,
	dialogTen: 10,
	dialogEleven: 11,
	dialogTwelve: 12,
	//* tooltips
	tooltipGreaseContainer: 13,
	tooltipKey: 14,
	tooltipDataScreen: 15,
	tooltipButtonSelect: 16,
	tooltipDispenser: 17,
	tooltipDraingrate: 18,
	tooltipCupgrate: 19,
	win: 300,
};

const stepRayCaster = {
	//* tooltip
	K_Contenedor_de_grano: steps.tooltipGreaseContainer,
	K_Llave: steps.tooltipKey,
	K_PantallaDeDatos: steps.tooltipDataScreen,
	K_BotonSeleccion: steps.tooltipButtonSelect,
	K_Dispensador: steps.tooltipDispenser,
	K_ParillaDeEscurrimiento: steps.tooltipDraingrate,
	K_ParillaPortaVaso: steps.tooltipCupgrate,
	//* tooltip --
	llaveAnimation: steps.dialogSix,
	contenedorGuardarAnimation: steps.dialogNine,
	cerrarPuertaAnimation: steps.dialogEleven,
};

export const Team2SubtopicTwoActivityFive = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch()
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema2], 5);
	const stepSelectRayCaster = useRef(0);

	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 2 act 5');
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.initScene, 4);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a01T2)
	})

	ObserverEmitter.on(EVENTS.team2.subtopicThree.clickedRayCaster, (step) => {
		const clickRayCaster = stepRayCaster[step];
		if (clickRayCaster === undefined) {
			return;
		}

		const isNextMove = stepSelectRayCaster.current === clickRayCaster;

		if (!isNextMove) {
			return;
		}

		if (clickRayCaster === steps.tooltipGreaseContainer) {
			hiddenSelectObject(steps.tooltipKey);
		}

		if (clickRayCaster === steps.tooltipKey) {
			hiddenSelectObject(steps.tooltipDataScreen);
		}

		if (clickRayCaster === steps.tooltipDataScreen) {
			hiddenSelectObject(steps.tooltipButtonSelect);
		}

		if (clickRayCaster === steps.tooltipButtonSelect) {
			hiddenSelectObject(steps.tooltipDispenser);
		}

		if (clickRayCaster === steps.tooltipDispenser) {
			hiddenSelectObject(steps.tooltipDraingrate);
		}

		if (clickRayCaster === steps.tooltipDraingrate) {
			hiddenSelectObject(steps.tooltipCupgrate);
		}

		if (clickRayCaster === steps.tooltipCupgrate) {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a02T2)
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.finishTooltipMachineKrea);
			stepSelectRayCaster.current = 0;
			setUiToShow(steps.dialogThree);
		}
	});

	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.animationLlaveKreaFinish, () => {
		stepSelectRayCaster.current = 0;
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a05T2)
		setUiToShow(steps.dialogSix);
	});

	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.animationSaveContenedorFinish, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a08T2)
		stepSelectRayCaster.current = 0;
		setUiToShow(steps.dialogNine);
	});

	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFour.animationCloseAnimationFinish, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a10T2)
		stepSelectRayCaster.current = 0;
		setUiToShow(steps.dialogEleven);
	});

	const activeEffectScene = (value) => {
		if (value === "K_Contenedor_de_grano") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_Contenedor_de_grano);
		}
		if (value === "K_Llave") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_Llave);
		}
		if (value === "K_PantallaDeDatos") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_PantallaDeDatos);
		}
		if (value === "K_BotonSeleccion") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_BotonSeleccion);
		}
		if (value === "K_Dispensador") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_Dispensador);
		}
		if (value === "K_ParillaDeEscurrimiento") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_ParillaDeEscurrimiento);
		}
		if (value === "K_ParillaPortaVaso") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.tooltipMachineKrea.K_ParillaPortaVaso);
		}

		if (value === "llaveAnimation") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.animationLlaveKreaInit);
		}
		if (value === "contenedorGuardarAnimation") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.animationSaveContenedorInit);
		}
		if (value === "cerrarPuertaAnimation") {
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.animationCloseAnimationInit);
		}
	};

	const hiddenSelectObject = (stepCaster = 0) => {
		const foundEntry = Object.entries(stepRayCaster).find(([key, value]) => value === stepCaster);
		if (!foundEntry) {
			console.log("no se encontro");
			return;
		}
		const [key] = foundEntry;
		activeEffectScene(key);
		ObserverEmitter.emit(EVENTS.team2.subtopicThree.stepUseRayCaster, key);
		stepSelectRayCaster.current = stepCaster;
		setUiToShow(-1);
	};
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2, 5, 6, 7, 8, 9].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.initScene, 4);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 5: Maquina Krea" />
					<DialogBarNew
						dialog={"¡Bien hecho! también tenemos nuestra maquina Krea, es momento de hablar de su modo de operación."}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.moveMachineKrea);
							setUiToShow(steps.viewActivity);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivity && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquinas de café"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<PanelInstrucionHands
						text="Explora tocando las áreas iluminadas."
						action={() => {
							hiddenSelectObject(steps.tooltipGreaseContainer);
						}}
						img={imgInstructionTeam2.team2_sub2_act_4_01}
					/>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						whitImg={true}
						dialog={"Su proceso operativo es muy similar a las otras máquinas como la de Kobalto."}
						percentage={"30%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a03T2)
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.visibleGarrafon);
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.visibleunCuartoAct4);
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						whitImg={true}
						dialog={
							"Paso 1: Verifica que el garrafón tenga al menos un cuarto de agua y que la manguera este por debajo de este nivel. Revisa que el sistema funcione correctamente."
						}
						percentage={"40%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a04T2)
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.hiddenGarrafon);
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.hiddenunCuartoAct4);
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						whitImg={true}
						dialog={
							"Paso 2: Abre la maquina girando la llave y estira la tapa hacia ti, levanta la tapa que esta arriba de los contenedores de polvo."
						}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							hiddenSelectObject(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						whitImg={true}
						dialog={
							"Paso 3: Verifica el nivel de polvo en cada contenedor retirándolo de la máquina y agitándolo. Si está por debajo del nivel mínimo, rellénalo hasta la marca indicada en la escala."
						}
						percentage={"60%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a06T2)
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFour.animationHiddenContenedor);
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						whitImg={true}
						dialog={
							"Nota: Recuerda rellenar los contenedores únicamente levantado la tapa de los 3 insertos, no es necesario girar los codos."
						}
						percentage={"70%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a07T2)
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						whitImg={true}
						dialog={
							"Paso 4: Coloca los contenedores en su lugar asegurándote de que encajen correctamente con la máquina. Gira la pieza trasera si es necesario."
						}
						percentage={"80%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							hiddenSelectObject(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						whitImg={true}
						dialog={"Paso 5: Gira el codo del paso de polvo de cada contendor hacia abajo el embudo (un poco inclinado)."}
						percentage={"85%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a09T2)
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						whitImg={true}
						dialog={
							"Paso 6: Ahora, procede a bajar la tapa ubicada encima de los contenedores. Una vez hecho esto, cierra la máquina con cuidado y gira la llave para finalizar el proceso."
						}
						percentage={"90%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							hiddenSelectObject(steps.dialogEleven);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogEleven && (
				<>
					<DialogBarNew
						whitImg={true}
						dialog={"Nota: Recuerda no lavar los contenedores o embudos, estos serán lavados en el mantenimiento que realizara Caffenio."}
						percentage={"90%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act5_a11T2)
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.initPosicitionCamare)
							ObserverEmitter.emit(EVENTS.characterAnimations.festejo);
							setUiToShow(steps.dialogTwelve);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogTwelve && (
				<>
					<DialogBarNew
						whitImg={true}
						dialog={
							"Importante: Para rellenar el contendor de granos, utiliza la llave con la que abres la máquina, levanta la tapa y rellena de café de grano regular."
						}
						percentage={"100%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="La máquina de Kobalto se distingue por su mantenimiento detallado, se cuidadoso y recuerda cada paso."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 5,
									pointsWin: 0,
									subtema: tasksId.tema2.activities.subtema2,
								})
							);
							navigator("/home2/tema2/subtema2/activitySix");
						}}
					/>
				</>
			)}
		</>
	);
};
